import { render, staticRenderFns } from "./CommercialProductList.vue?vue&type=template&id=213eb70a&"
import script from "./CommercialProductList.vue?vue&type=script&lang=js&"
export * from "./CommercialProductList.vue?vue&type=script&lang=js&"
import style0 from "./CommercialProductList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports